module.exports = __webpack_public_path__ + "static/media/llamadaVideoLlamada__Llamada.73f63765.svg";